<template>
  <v-row no-gutters>
    <v-col cols="12">
      <div v-for="(uploadedFile, index) in value">
        <file-uploader
          :value="uploadedFile"
          @input="
            (val) => {
              $emit('upload', { val, index });
            }
          "
        />
        <a
          v-if="index !== 0"
          class="ml-2"
          href="javascript:void(0)"
          @click="$emit('remove-file-selector', index)"
          >Remove</a
        >
      </div>
    </v-col>
    <p class="ml-2">
      <a href="javascript:void(0)" @click="$emit('add-file')"
        >Upload Another File</a
      >
    </p>
  </v-row>
</template>

<script>
import FileUploader from "./FileUploader.vue";

export default {
  name: "file-multiple-upload",
  components: {
    FileUploader,
  },
  props: {
    value: {
      type: [],
      default: () => [],
    },
    articleOfIncorporationUpload: {
      type: String,
      default: null,
    },
    w9Upload: {
      type: String,
      default: null,
    },
  },
};
</script>
